import { PrimaryButton, SecondaryButton } from './AmeButton'
import styled, { css } from 'styled-components'

export const ResponsiblePrimaryButton = styled(PrimaryButton)`
    ${({ width }) => {
        if (width) {
            return css`
                width: width;
            `
        } else {
            return css`
                width: 100%;
            `
        }
    }}

    @media (min-width: 1100px) {
        width: 13.75em;
    }
`

export const ResponsibleSecondaryButton = styled(SecondaryButton)`
    ${({ width }) => {
        if (width) {
            return css`
                width: width;
            `
        } else {
            return css`
                width: 100%;
            `
        }
    }}

    @media (min-width: 1100px) {
        width: 13.75em;
    }
`
